export function formatDate(iso) {
  if (!iso) return "TBD";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }).toUpperCase();
  } catch { return "TBD"; }
}

export function formatDateTime(iso) {
  if (!iso) return "TBD";
  try {
    const d = new Date(iso);
    const date = d.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" }).toUpperCase();
    const time = d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });
    return `${date} · ${time}`;
  } catch { return "TBD"; }
}

export function relativeTime(iso) {
  if (!iso) return "";
  const diff = new Date(iso).getTime() - Date.now();
  const abs = Math.abs(diff);
  const past = diff < 0;
  const days = Math.floor(abs / 86400000);
  const hours = Math.floor((abs % 86400000) / 3600000);
  const mins = Math.floor((abs % 3600000) / 60000);
  if (days > 0) return past ? `T+${days}D` : `T-${days}D`;
  if (hours > 0) return past ? `T+${hours}H` : `T-${hours}H`;
  return past ? `T+${mins}M` : `T-${mins}M`;
}

export function countdown(iso) {
  if (!iso) return { d: 0, h: 0, m: 0, s: 0, past: false, valid: false };
  const diff = new Date(iso).getTime() - Date.now();
  const past = diff < 0;
  const abs = Math.abs(diff);
  return {
    d: Math.floor(abs / 86400000),
    h: Math.floor((abs % 86400000) / 3600000),
    m: Math.floor((abs % 3600000) / 60000),
    s: Math.floor((abs % 60000) / 1000),
    past,
    valid: true,
  };
}

export function statusColor(name) {
  if (!name) return "var(--sat-text-dim)";
  const n = name.toLowerCase();
  if (n.includes("success") || n.includes("go")) return "var(--sat-cyan)";
  if (n.includes("fail") || n.includes("abort")) return "var(--sat-danger)";
  if (n.includes("hold") || n.includes("tbd") || n.includes("tbc")) return "var(--sat-amber)";
  if (n.includes("launched")) return "var(--sat-cyan)";
  return "var(--sat-text-dim)";
}
